var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-snackbar",
    {
      staticStyle: { top: "25px" },
      attrs: {
        top: "",
        "content-class": "pa-0",
        color: _vm.alertType,
        timeout: _vm.alertType !== "success" ? -1 : _vm.timeout
      },
      model: {
        value: _vm.alert,
        callback: function($$v) {
          _vm.alert = $$v
        },
        expression: "alert"
      }
    },
    [
      _c(
        "v-alert",
        {
          staticClass: "my-0",
          attrs: {
            dense: "",
            border: "left",
            dismissible: "",
            prominent: _vm.alertType !== "success",
            type: _vm.alertType,
            timeout: _vm.timeout
          },
          model: {
            value: _vm.alert,
            callback: function($$v) {
              _vm.alert = $$v
            },
            expression: "alert"
          }
        },
        [
          _vm._v("\n    " + _vm._s(_vm.alertMessage) + "\n    "),
          _vm.messages && _vm.messages.length > 0
            ? _vm._l(_vm.messages, function(message, i) {
                return _c("div", { key: i }, [
                  _vm._v("\n        " + _vm._s(message) + "\n      ")
                ])
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.errors && _vm.errors.length > 0
            ? _vm._l(_vm.errors, function(error, i) {
                return _c("div", { key: i }, [
                  _vm._v("\n        " + _vm._s(error) + "\n      ")
                ])
              })
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a9332c72", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a9332c72","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AlertBar.vue
// module id = null
// module chunks = 